/**
 * « Passages à relancer » — bloc de la saisie quotidienne : les personnes que J'AI notées « il doit
 * passer » et dont la relance est échue. Il informe ; il ne bloque jamais la validation de la
 * journée. Sa route vit sous /api/team/daily-log/, ouverte pendant le verrou de saisie. Rendu depuis
 * l'écran de blocage (`depuisLeBlocage`), le lien vers la liste est masqué : elle s'ouvrirait dessous.
 */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CalendarClock } from 'lucide-react';
import { jourCourt, lirePassagesARelancer, quiEstAttendu } from '../../lib/numerosFiches';
import NumeroAppel from '../telephone/NumeroAppel';

export default function PassagesARelancerBloc({ depuisLeBlocage = false }) {
  const [passages, setPassages] = useState([]);

  useEffect(() => {
    let demonte = false;
    lirePassagesARelancer()
      .then((res) => { if (!demonte && res && res.ok) setPassages(res.passages || []); })
      .catch(() => {});                                // un bloc d'information ne casse pas la saisie
    return () => { demonte = true; };
  }, []);

  if (passages.length === 0) return null;
  return (
    <div data-testid="passages-a-relancer" style={{ marginBottom: 12, padding: '10px 12px', borderRadius: 8, background: '#fff', border: '1px solid #fcd34d' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6, flexWrap: 'wrap' }}>
        <CalendarClock size={14} color="#b45309" />
        <strong style={{ fontSize: 13, color: '#92400e' }}>
          {passages.length} passage{passages.length > 1 ? 's' : ''} attendu{passages.length > 1 ? 's' : ''} à relancer
        </strong>
        {!depuisLeBlocage && (
          <Link to="/call-history?passages=1" style={{ fontSize: 12, color: '#4338ca' }}>Ouvrir les passages attendus</Link>
        )}
      </div>
      <div style={{ display: 'grid', gap: 4 }}>
        {passages.map((fiche) => (
          <div key={fiche.id} style={{ display: 'flex', gap: 8, flexWrap: 'wrap', fontSize: 12 }}>
            <span style={{ fontWeight: 600, color: '#1e293b' }}>{quiEstAttendu(fiche)}</span>
            {fiche.numero && <NumeroAppel numero={fiche.numero} clientId={fiche.client_id} lien={false} style={{ fontFamily: "'IBM Plex Mono', monospace", color: '#475569' }} />}
            <span style={{ color: '#991b1b' }}>à relancer depuis le {jourCourt(fiche.passage.relance_le)}</span>
            {(fiche.notes || [])[0] && (
              <span style={{ color: '#64748b', minWidth: 0 }}>
                {fiche.notes[0].prive && <span style={{ color: '#dc2626' }}>privée : </span>}{fiche.notes[0].texte}
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
